import {
  IcRankBronze,
  IcRankGold,
  IcRankNormal,
  IcRankSilver,
} from "@/assets/icons"

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL
export const API_SECURE_CHAT_BASE_URL = `${API_BASE_URL}/1/${import.meta.env.VITE_API_SECURE_CHAT_NAMESPACE
  }`
export const V1_API_BASE_URL = `${API_BASE_URL}/1/${import.meta.env.VITE_API_MAIN_NAMESPACE
  }`

export const GAS_ACCOUNT_API_BASE_URL = `${API_BASE_URL}/1/${import.meta.env.VITE_API_GAS_ACCOUNT_NAMESPACE
  }`
export const V2_GAS_ACCOUNT_API_BASE_URL = `${API_BASE_URL}/2/${import.meta.env.VITE_API_GAS_ACCOUNT_NAMESPACE
  }`

export const AVACUS_SNS_WEB_URL = import.meta.env.VITE_AVACUS_SNS_WEB_URL

export const CookieKey = {
  AuthToken: "gas-sponsor-auth-token",
}

export const AuthQueryKeys = {
  AVACUS_PROFILE: "avacus_profile",
  NONCE: "nonce",
}

export enum AVACUS_RANK {
  GOLD = "gold",
  SILVER = "silver",
  BRONZE = "bronze",
  NORMAL = "normal",
}

export const AVACUS_RANK_ICON = {
  [AVACUS_RANK.GOLD]: IcRankGold,
  [AVACUS_RANK.SILVER]: IcRankSilver,
  [AVACUS_RANK.BRONZE]: IcRankBronze,
  [AVACUS_RANK.NORMAL]: IcRankNormal,
}

export const AVACUS_RANKING_LEVELS = {
  gold: 90,
  silver: 75,
  bronze: 50,
}

/** App name sent when registering device for push (POST /v1/devices). */
export const PUSH_APP_NAME = "Avacus Gas Sponsor"
/** Platform sent when registering device for push. */
export const PUSH_PLATFORM = "browser"
